import React, { useEffect, useState } from "react";
import { Row, Col, Button, notification } from "antd";
import styles from "./GroceryAddItems.module.scss";
import {
  DeleteOutlinedIcon,
  MinusCircleOutlinedIcon,
  PlusCircleOutlinedIcon,
} from "../../../assets/images";
import {
  AddTempGroceryCartPayload,
  CartGroceryItem,
  GroceryItem,
} from "../../../types/GroceryTypes";
import {
  addTempGroceryCart,
  getTemporaryGroceryCart,
} from "../../../services/GroceryService";
import { useParams } from "react-router";
import { useGroceryCtx } from "../../../context/GroceryContext";

type Prop = {
  groceryItem: GroceryItem | CartGroceryItem;
  groceryCartCount: number;
  currentCount: number;
  setCurrentCount: Function;
};

enum GroceryCartAction {
  Add = 1,
  Subtract,
  Delete,
}

function GroceryAddItems({
  groceryItem,
  groceryCartCount,
  currentCount,
  setCurrentCount,
}: Prop) {
  const [groceryAddAction, setGroceryAddAction] = useState<number | null>(null);
  const { cachedGroceryCartItemsCtx } = useGroceryCtx();
  const [, setCachedGroceryCartItems] = cachedGroceryCartItemsCtx;
  const { personId } = useParams<{ personId: string }>();

  const updateGroceryCart = async (groceryAddAction: number) => {
    const itemCount = 1;
    const requestBody: AddTempGroceryCartPayload = {
      serviceUserPersonId: Number(personId),
      groceryCartAction: groceryAddAction,
      groceryCart: {
        groceryId: groceryItem.groceryId,
        categoryName: groceryItem.categoryName,
        productName: groceryItem.productName,
        imageKey: groceryItem.imageKey,
        quantity: itemCount,
        weight: groceryItem.weight,
        weightType: groceryItem.weightType,
        size: groceryItem.size,
        cost: groceryItem.cost,
        costType: groceryItem.costType,
      },
    };

    await addTempGroceryCart(requestBody);
  };

  useEffect(() => {
    if (groceryAddAction !== null && currentCount !== null) {
      const fetchTemporaryGroceryCart = async () => {
        try {
          await updateGroceryCart(groceryAddAction);
          const tempGroceryCart = await getTemporaryGroceryCart(
            Number(personId)
          );
          setCachedGroceryCartItems(tempGroceryCart.getGroceryCarts);
        } catch (error) {
          notification.error({
            message: "Failed to fetching temporary grocery cart",
          });
        }
      };

      fetchTemporaryGroceryCart();
    }
  }, [groceryAddAction, currentCount]);

  const handleRemoveGroceryItem = () => {
    setCurrentCount((prev: number) => prev - 1);
    setGroceryAddAction(GroceryCartAction.Subtract);
  };

  const handleAddGroceryItem = () => {
    setCurrentCount((prev: number) => prev + 1);
    setGroceryAddAction(GroceryCartAction.Add);
  };

  const handleRemoveAllGroceryItems = () => {
    setCurrentCount(0);
    setGroceryAddAction(GroceryCartAction.Delete);
  };

  return (
    <Row>
      {groceryCartCount >= 2 && (
        <Col className={`${styles.addItems} ${styles.removeBtnContainer}`}>
          <Button
            className={`${styles.addItems} ${styles.removeButton}`}
            onClick={handleRemoveAllGroceryItems}
          >
            <img
              src={DeleteOutlinedIcon}
              alt="trash icon"
              className={styles.icon}
            />
          </Button>
        </Col>
      )}

      <Col>
        <Row
          className={`${styles.addItems} ${styles.counterContainer}`}
          align="middle"
          justify="center"
        >
          <Col span={6} className={styles.addItems}>
            <Button
              className={`${styles.addItems} ${styles.counterButton}`}
              onClick={handleRemoveGroceryItem}
            >
              <img
                src={
                  groceryCartCount === 1
                    ? DeleteOutlinedIcon
                    : MinusCircleOutlinedIcon
                }
                alt="minus icon"
                className={styles.icon}
              />
            </Button>
          </Col>
          <Col
            span={6}
            className={`${styles.addItems} ${styles.counterNumber}`}
          >
            {groceryCartCount}
          </Col>
          <Col span={6} className={styles.addItems}>
            <Button
              className={`${styles.addItems} ${styles.counterButton}`}
              onClick={handleAddGroceryItem}
            >
              <img
                src={PlusCircleOutlinedIcon}
                alt="plus icon"
                className={styles.icon}
              />
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default GroceryAddItems;
